<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="pie"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'PieCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    labelsData: {
      type: Array,
      required: true,
    },
    colorsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'pie',
        },
        labels: [],
        colors: [],
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -10,
            },
          },
        },
        dataLabels: {
          offset: -10,
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex]
            const count = opts.w.globals.series[opts.seriesIndex]
            return [name, `%${Math.round(val)}`, `${count.toFixed(0)}`]
          },
        },
        legend: {
          show: false,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    labelsData: 'setData',
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.labels = this.labelsData
      this.chartOptions.colors = this.colorsData
    },
  },
}
</script>
